import React, { Component } from "react"
import { connect } from "react-redux"
import { Arwes, Button, Project, Words } from "arwes"
import Icon from "@mdi/react"
import { mdiChemicalWeapon, mdiRobot } from "@mdi/js"
import styled from "styled-components"
import get from "lodash.get"
import { checkIsAuthenticated, getUserInformation } from "./redux/reducers"
import { Link, Redirect } from "react-router-dom"
import { listPostsByUser } from "../post/redux/reducers"
import { isAdminUser } from "../../common/util/isAdmin"
import { avatarUrl } from "../../common/util/avatars"
import PostByUser from "../post/PostByUser"
import { MarginTop } from "../../common/styled/MarginTop"
import {
  ContentColumn,
  PageBlock,
  PageOffset
} from "../../common/styled/Page"

const ASSETS = `${process.env.PUBLIC_URL}/assets`

const isProduction = process.env.NODE_ENV === "production"
const envURL =
  process.env.REACT_APP_API_URL || "https://cybersocial.herokuapp.com"
const PUBLIC_URL = isProduction ? envURL : "http://localhost:8080"

const ButtonBar = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 600px) {
    justify-content: flex-start;
  }
`

const ProfileRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 0;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const ProfileInfo = styled.div`
  box-sizing: border-box;
  flex: 1 1 320px;
  min-width: 0;
  padding: 20px;
  word-break: break-word;

  @media (max-width: 600px) {
    flex-basis: auto;
    padding: 12px 0;
    width: 100%;
  }
`

const AvatarPane = styled.div`
  box-sizing: border-box;
  flex: 0 0 130px;
  margin: 0;
  padding: 20px;
  text-align: center;

  @media (max-width: 600px) {
    flex-basis: auto;
    padding: 12px 0 4px;
    width: 100%;
  }
`

const PostsList = styled.div`
  margin: 30px 0;

  @media (max-width: 600px) {
    margin: 20px 0 0;
  }
`

class Profile extends Component {
  state = {
    user: "",
    redirectToSignin: false
  }

  get isAuthenticated() {
    const { user } = this.props
    return !!user.loaded.token
  }

  notAuthorized() {
    return <Redirect to="/signIn" />
  }

  renderImage = () => {
    const { user } = this.props
    const getUserId = get(user, "loadedUser._id", "000")
    const avatar = get(user, "loadedUser.avatar")
    const photoUrl = avatar
      ? avatarUrl(avatar)
      : `${PUBLIC_URL}/user/photo/${getUserId}?${new Date().getTime()}`
    const photoFallBack = `${ASSETS}/avatarm.png`
    return (
      <AvatarPane>
        <img
          style={{ height: "auto", maxWidth: "80px", width: "100%" }}
          animate
          alt={"profile"}
          src={photoUrl}
          onError={e => {
            if (e.target.src !== photoFallBack) {
              e.target.src = photoFallBack
            }
          }}
        />
      </AvatarPane>
    )
  }

  componentDidMount() {
    const getUserId = this.props.match.params.userId

    this.props.getUserInformation(getUserId)
    this.props.listPostsByUser(getUserId)
  }

  componentWillReceiveProps(nextProps) {
    const getUserId = this.props.match.params.userId
    const newId = nextProps.match.params.userId

    if (getUserId !== newId) {
      this.props.getUserInformation(newId)
    }
  }

  hasPermission = () => {
    const { user } = this.props
    const loggedUser = get(user, "loaded.user._id")
    const profileUser = get(user, "loadedUser._id")
    if (loggedUser != null && loggedUser === profileUser) {
      return true
    }
    return false
  }

  render() {
    const { user, posts, isAdmin } = this.props
    const isCurrentUser = this.hasPermission()

    const isProduction = process.env.NODE_ENV === "production"
    const enableDelete = !isProduction

    const safeUser = {
      loadedUser: {
        name: "",
        email: "",
        about: "user didnt provide any info about him",

        ...user.loadedUser
      }
    }

    const getName = safeUser.loadedUser.name
    const getEmail = safeUser.loadedUser.email
    const getId = safeUser.loadedUser._id
    const getAbout = safeUser.loadedUser.about

    if (!this.isAuthenticated) {
      //return this.notAuthorized()
    }

    return (
      <Arwes>
        <PageOffset isExpanded={this.props.isExpanded}>
          <MarginTop />
          <ContentColumn>
            <PageBlock>
              <Project animate header="Profile">
                {anim => (
                  <ProfileRow>
                    {this.renderImage()}

                    <ProfileInfo>
                      <Words animate show={anim.entered}>
                        {getName}
                      </Words>
                      <div>
                        {getEmail && (
                          <React.Fragment>
                            <Words animate show={anim.entered}>
                              {getEmail}
                            </Words>
                            <br />
                          </React.Fragment>
                        )}
                        <Words animate show={anim.entered}>
                          {getAbout}
                        </Words>
                        <div style={{ marginTop: "30px" }} />

                        {(isCurrentUser || isAdmin || enableDelete) && (
                          <ButtonBar>
                            <Button
                              animate
                              layer="success"
                              onClick={() =>
                                this.props.history.push(`/editUser/${getId}`)
                              }
                            >
                              <Icon
                                path={mdiChemicalWeapon}
                                size={0.5}
                                color="green"
                                spin
                              />{" "}
                              EDIT PROFILE
                            </Button>
                            <Button
                              animate
                              layer="alert"
                              onClick={() =>
                                this.props.history.push(`/deleteUser/${getId}`)
                              }
                            >
                              <Icon path={mdiRobot} size={0.5} color="red" />{" "}
                              DELETE USER
                            </Button>
                            <Button
                              animate
                              layer="alert"
                              onClick={() => this.props.history.push("/grid")}
                            >
                              <i className="mdi mdi-chemical-weapon" /> BACK TO
                              HOME
                            </Button>
                          </ButtonBar>
                        )}
                      </div>
                    </ProfileInfo>
                  </ProfileRow>
                )}
              </Project>
              <PostsList>
                {posts.userPosts.length &&
                  posts.userPosts.map(post => {
                    return (
                      <Link
                        key={post._id}
                        to={`/post/${post._id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <PostByUser post={post} />
                      </Link>
                    )
                  })}
              </PostsList>
            </PageBlock>
          </ContentColumn>
        </PageOffset>
      </Arwes>
    )
  }
}

const mapState = state => {
  return {
    user: state.user,
    posts: state.posts,
    isAdmin: isAdminUser(state)
  }
}

export default connect(
  mapState,
  { checkIsAuthenticated, getUserInformation, listPostsByUser }
)(Profile)
